var _NativeModules$GAIOSV;
import { Dimensions, NativeModules, Platform } from 'react-native';
import { getScaledPx, getUnscaledPx } from '../../utils/rn/tools';
export var prefix_cls = 'ChatbotUI';
export var brand = '#ee4d2d';
export var gray_light = '#efefef';
export var gray_1 = 'rgba(0, 0, 0, 0.87)';
export var gray_2 = 'rgba(0, 0, 0, 0.65)';
export var gray_3 = 'rgba(0, 0, 0, 0.54)';
export var gray_4 = 'rgba(0, 0, 0, 0.4)';
export var gray_5 = 'rgba(0, 0, 0, 0.26)';
export var gray_6 = 'rgba(0, 0, 0, 0.09)';
export var gray_7 = 'rgba(0, 0, 0, 0.06)';
export var light_1 = '#eeeeee';
export var light_2 = 'rgba(255, 255, 255, 0.87)';
export var white = '#ffffff';
export var black = '#000000';
export var blue = '#2673dd';
export var link = '#08f';
export var mask_bg = black;
export var mask_bg_gray = 'rgba(0, 0, 0, 0.3)'; // Avatar

export var avatar_size = 36;
export var avatar_size_sm = 24;
export var avatar_size_lg = 40;
export var avatar_square_border_radius = 4;
export var zindex_bubble_angle = -1;
export var zindex_bubble = 0;
export var zindex_navbar = 1;
export var zindex_mask = 10;
export var zindex_modal_content = 12;
var safeAreaInsetsBottom = (_NativeModules$GAIOSV = NativeModules.GAIOSViewUtility) === null || _NativeModules$GAIOSV === void 0 ? void 0 : _NativeModules$GAIOSV.safeAreaInsetsBottom;
export var safe_area_insets_bottom = Platform.select({
  ios: safeAreaInsetsBottom || 0,
  android: 0
}) || 0;
export var FONT_WEIGHT_REGULAR = Platform.select({
  android: {
    fontWeight: '400',
    // use sans-serif instead of Roboto https://jira.shopee.io/browse/SPFE-77495
    fontFamily: 'sans-serif'
  },
  ios: {
    fontWeight: '400'
  },
  web: {
    fontWeight: '400'
  }
});
export var FONT_WEIGHT_MEDIUM = Platform.select({
  android: {
    fontWeight: '500',
    fontFamily: 'sans-serif-medium'
  },
  ios: {
    fontWeight: '500'
  },
  web: {
    fontWeight: '500'
  }
});
export var FONT_WEIGHT_BOLD = Platform.select({
  android: {
    // NOTE: Android: fontFamily is sans-serif, so bold is created by fontWeight
    fontWeight: '700',
    fontFamily: 'sans-serif'
  },
  ios: {
    fontWeight: '700'
  },
  web: {
    fontWeight: '700'
  }
});
export var WindowWidth = Dimensions.get('window').width;
export var DialogueMaxWidth = WindowWidth * 0.8 + 24; // DialogueMaxWidth - style.bubble.marginLeft - style.bubble.marginRight;
// 使用 getUnscaledPx 是为了经过 CustomStyleSheet 处理后不被缩放

export var BubbleInnerWidth = getUnscaledPx(DialogueMaxWidth - getScaledPx(15) - getScaledPx(8));